import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { toast } from "react-toastify";

export class _LocatorStore {

  obs = observable({
    locators: [],
    locators_length: 0
  })

  async handleLocators(page: number, text: string, tipo: string) {

    let params = {
      page: page,
      limit: 15,
      text,
      tipo
    }

    try {

      let resp = await api_adm.post('/api/admin/locators/index', params)

      this.obs.locators_length = 0
      this.obs.locators = []

      if (resp.data.itens.length > 0) {
        this.obs.locators = resp.data.itens
        this.obs.locators_length = resp.data.count
      }

    } catch (ex) { }

  }

  async handleCreateLocator(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/locator/create', params)

      if (resp.data.ok == true) {

        toast.success('Locator criado com sucesso.', {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

  async handleUpdateLocator(params: any) {

    try {

      let resp = await api_adm.post('/api/admin/locator/update', params)

      if (resp.data.ok == true) {

        toast.success('Locator atualizado com sucesso.', {});

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

  }

  async handleDeleteLocator(id: string) {

    try {

      let resp = await api_adm.delete(`/api/admin/locator/${id}`)

      if (resp.data.ok == true) {

        toast.success('Locator deletado com sucesso.', {});
        return true

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch { }

    return false

  }

}

export const LocatorStore = new _LocatorStore();
